import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowDown, Star } from 'lucide-react';
import { useCurrency } from '../contexts/CurrencyContext';
import { PricingPopup } from './PricingPopup';
export function HeroSection() {
  const {
    formatPrice
  } = useCurrency();
  const [showPricing, setShowPricing] = useState(false);
  return <section className="relative pt-16 pb-20 px-4 md:px-6 overflow-hidden max-w-5xl mx-auto" data-id="element-79">
      <div className="flex flex-col items-center text-center" data-id="element-80">
        {/* Top Label */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-teal/10 text-teal-800 font-medium text-sm md:text-base mb-8" data-id="element-81">
          <Star className="w-4 h-4 fill-current" data-id="element-82" />
          <span data-id="element-83">For grandmas who want to matter, not just spend</span>
        </motion.div>

        {/* Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="font-serif text-4xl md:text-6xl lg:text-7xl font-bold text-charcoal leading-tight mb-6 max-w-4xl" data-id="element-84">
          Stop buying toys they forget.{' '}
          <span className="text-coral italic" data-id="element-85">
            Give them time they'll remember.
          </span>
        </motion.h1>

        {/* Lead Paragraph */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="max-w-2xl mx-auto mb-12" data-id="element-86">
          <p className="text-lg md:text-xl text-warm-gray leading-relaxed" data-id="element-87">
            If you've ever watched your grandkid open a gift… smile… and then
            move on like it never happened—this is for you.
          </p>
        </motion.div>

        {/* Product Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="relative w-full max-w-md md:max-w-lg mb-12" data-id="element-88">
          <div className="absolute inset-0 bg-coral/20 rounded-3xl transform rotate-3 scale-105 blur-xl" data-id="element-89"></div>
          <img src="https://cdn.magicpatterns.com/uploads/8YRuhT8tMgeUWg9hfzk3BF/image_1.png" alt="Grandma & Me Memory Tickets on a phone screen" className="relative z-10 rounded-3xl shadow-2xl border-4 border-white transform -rotate-1 hover:rotate-0 transition-transform duration-500" data-id="element-90" />
        </motion.div>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.7
      }} className="flex flex-col items-center gap-4" data-id="element-91">
          <button onClick={() => setShowPricing(true)} className="bg-coral hover:bg-coral-hover text-white text-lg md:text-xl font-semibold px-8 py-4 rounded-full shadow-lg shadow-coral/30 transition-all transform hover:-translate-y-1 w-full md:w-auto" data-id="element-92">
            Download Memory Tickets
          </button>
          <p className="text-sm text-warm-gray font-medium flex items-center gap-2" data-id="element-93">
            <span data-id="element-94">Instant download</span> • <span data-id="element-95">Print at home</span> •{' '}
            <span data-id="element-96">Ready in 7 minutes</span>
          </p>
        </motion.div>
      </div>

      <PricingPopup isOpen={showPricing} onClose={() => setShowPricing(false)} data-id="element-97" />
    </section>;
}